
angular.module('bmsApp.training').controller('TrainingRecordModalFormCtrl', [
	'$log',
	'$scope',
	'$q',
	'$modalInstance',
	'$ngBootbox',
	'EmployeeOptionsSvc',
	'TrainingCourseSvc',
	'TrainingRecordSvc',
	'training_record', function (
		$log,
		$scope,
		$q,
		$modalInstance,
		$ngBootbox,
		EmployeeOptionsSvc,
		TrainingCourseSvc,
		TrainingRecordSvc,
		training_record) {

		$scope.datePickerConfig = angular.copy($scope.config.datePicker.basic);
		$scope.datePickerConfig.options.parentEl = '.modal-content';

		training_record._end = null;
		training_record._start = null;
		training_record.end = null;
		training_record.start = null;
		training_record.source = null;

		var employeeOptionsPromise = EmployeeOptionsSvc.employee();
		var trainingCourseOptionsPromise = TrainingCourseSvc.options();
		var promises = [employeeOptionsPromise, trainingCourseOptionsPromise];
		$scope.loading = true;
		$scope.processing = false;
		$q.all(promises).then(function (responses) {
			$scope.training_record = training_record;
			$scope.employeeOptions = responses[0].data.options;
			$scope.trainingCourseOptions = responses[1].data.options;
			$scope.loading = false;
		}, function (error) {
			$log.error(error);
		});

		$scope.formvalidatorconfig = {
			submitHandler: function (form) {
				$scope.submit($scope.training_record);
			},
			errorPlacement: function (error, element) {
				error.appendTo('#training-record-errors');
			},
			errorContainer: '#training-record-errors'
		};

		$scope.submit = function (training_record) {
			$scope.processing = true;
			var modalResult = {};
			var savePromise = training_record.id ? TrainingRecordSvc.update(training_record.id, training_record) : TrainingRecordSvc.create(training_record);
			savePromise
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.action = training_record.id ? 'update' : 'create';
					modalResult.training_record = training_record;
					$modalInstance.close(modalResult);
				}, function (error) {
					modalResult.error = error;
					$modalInstance.close(modalResult);
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.delete = function (training_record) {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					var modalResult = {};
					TrainingRecordSvc.delete(training_record.id)
						.then(function (response) {
							modalResult.success = response.data.success;
							modalResult.action = 'delete';
							$modalInstance.close(modalResult);
						}, function (error) {
							$log.error(error);
							$modalInstance.close(modalResult);
						});
				});
		};

		$scope.cancel = function () {
			$modalInstance.dismiss('cancel');
		};

	}]);
